import axios from '../../axios'
import {encrypt} from "@/utils/crypt";

/*
 * 系统登录模块
 */

// 登录
export const login = data => {
  let params = {
    data: encrypt(JSON.stringify(data))
  };
  return axios({
    url: '/system/login/loginSecret',
    method: 'post',
    params
  })
}

// 登出
export const logout = () => {
  return axios({
    url: '/system/login/logout',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/login.js